import React, { useRef } from 'react';
import { Typography } from 'fronton-react';
import { LinkWithGAPromoClick, Section } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import { createElementKey } from 'utils';
import {
  brandsCards,
  brandsCard,
  brandsCardImage,
  brandsTitle,
} from './brands-styles';

type BrandCardStructure = {
  image: {
    srcLd: string;
    srcM: string;
  };
  name: string;
  title?: string;
  href?: string;
}

type TProps = {
  elementBlock: string;
  title: string;
  brands: BrandCardStructure[];
};

export const Brands: React.FC<TProps> = ({ brands, elementBlock, title }) => {
  const cardRefs = useRef<HTMLAnchorElement[]>([]);
  const promotions = brands.map((brand: BrandCardStructure, index: number) => ({
    name: elementBlock,
    creative: brand.name,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  return (
    <Section>
      <Typography className={brandsTitle} variant="h3" size="extra" as="h2">
        {title}
      </Typography>

      <div className={brandsCards}>
        {brands.map(({ title: cardTitle, name, image, href }, index) => (
          <LinkWithGAPromoClick
            bannerRefs={cardRefs}
            className={brandsCard}
            elementBlock={elementBlock}
            key={createElementKey('brand', index)}
            position={index}
            promotion={promotions[index]}
            href={href}
            title={name}
          >
            <picture>
              <source
                srcSet={image.srcLd}
                media={lowerBoundsBreakpoints['--from-tablet']}
              />
              <img
                alt={`Изображение бренда ${title}`}
                className={brandsCardImage}
                src={image.srcM}
              />
            </picture>
            {cardTitle && <Typography variant="l" size="body_accent">{cardTitle}</Typography>}
          </LinkWithGAPromoClick>
        ))}
      </div>
    </Section>
  );
}
